module.exports = __webpack_public_path__ + "img/BTS-alt.06048936.svg";